module.exports = __webpack_public_path__ + "img/cupshe.41d17f04.png";